<!--
 * @Description  : 项目结构右侧列表
 * @Author       : 钱磊
 * @Date         : 2023-04-06 09:37:15
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-26 14:47:22
 * @FilePath     : \dx_execute_admin\src\views\business-setting\structure-type\components\right_structure.vue
-->
<!--  -->
<template>
	<div class="h100">
		<div class="w-table-layout have-footer">
			<div class="w-table-content"
				 ref="content">
				<vxe-table align="center"
						   auto-resize
						   border
						   :data="tableObj.data"
						   :loading="tableObj.loading"
						   resizable
						   ref="tableData"
						   size="small"
						   height="100%"
						   highlight-current-row
						   highlight-hover-row
						   show-overflow="tooltip"
						   show-header-overflow="tooltip"
						   :edit-config="{ trigger: 'click', mode: 'cell', enabled: isEdit }"
						   :tree-config="{
								children: 'children',
								expandAll: true,
								parentField: 'pid',
								indent: 10,
								iconOpen: 'el-icon-folder-opened',
								iconClose: 'el-icon-folder'
							}"
						   @current-change="onCurrentChange">
					<vxe-column type="seq"
								title="序号"
								align="center"
								width="100"></vxe-column>
					<vxe-column title="操作"
								width="110">
						<template v-slot="{ row, $rowIndex }">
							<!-- 编辑时新增按钮+结构选择 -->
							<el-dropdown class="mr20"
										 @command="handleCommand($event, row)"
										 v-if="isEdit">
								<span class="el-dropdown-link">
									<el-button size="small"
											   type="text"
											   title="添加下一级"
											   icon="el-icon-folder-add"
											   v-if="row.level < 6">
									</el-button>
								</span>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item v-for="(item, index) in showList"
													  :key="'结构' + index"
													  :command="item.value"
													  :disabled="handleDisabled(item, row)">{{ item.sname }}</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<!-- 禁用情况下新增按钮 -->
							<el-button v-else
									   type="text"
									   class="table-operation-icon"
									   :disabled="!isEdit"
									   title="添加下一级"
									   icon="el-icon-folder-add">
							</el-button>
							<template v-if="row.level != 1">
								<el-button type="text"
										   @click="tableBtnClick('copy', row)"
										   :disabled="copyDisabled(row)"
										   title="复制"
										   icon="el-icon-copy-document">
								</el-button>
								<el-button type="text"
										   title="删除"
										   :disabled="formatEdit(row)"
										   icon="el-icon-delete"
										   @click="tableBtnClick('delete', row, $rowIndex)">
								</el-button>
							</template>
						</template>
					</vxe-column>
					<vxe-column title="是否生效"
								width="100">
						<template v-slot="{ row }">
							<vxe-switch v-model="row.status"
										:open-label="row.pid != '0' ? '是' : '全开'"
										:open-value="1"
										:close-label="row.pid != '0' ? '否' : '全关'"
										:close-value="0"
										:disabled="!isEdit"
										@change="tableBtnClick('change', row)"></vxe-switch>
						</template>
					</vxe-column>
					<vxe-column field="sname"
								title="节点名称"
								min-width="150"
								tree-node
								align="left"
								:edit-render="{}">
						<template #edit="{ row }">
							<vxe-input v-model="row.sname"
									   type="text"
									   maxlength="100"
									   show-word-limit></vxe-input>
						</template>
					</vxe-column>
					<vxe-column field="nodeTypeName"
								title="结构"
								width="150">
						<template v-slot="{ row }">
							<div v-if="row.level == 1">-</div>
							<div v-else>{{ row.nodeTypeName || '-' }}</div>
						</template>
					</vxe-column>
					<vxe-column field="nodeCode"
								title="节点类型"
								min-width="200"
								:edit-render="{}">
						<template #default="{ row }">
							<span>{{ formatType(row) || '-' }}</span>
						</template>
						<template #edit="{ row }">
							<vxe-select v-model="row.nodeCode"
										transfer>
								<vxe-option v-for="item in handleNode(row)"
											:key="item.value"
											:value="item.value"
											:label="item.sname"></vxe-option>
							</vxe-select>
						</template>
					</vxe-column>
				</vxe-table>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { getProTree, saveProTree } from '@/api/modules/structureType.js'

export default {
	name: '',
	components: {},
	props: {
		isEdit: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			btnLoading: false,
			loading: false,
			//表格对象
			tableObj: {
				loading: false,
				data: [], //数据源
				defaultData: [], //查询时复制一份
				currentPage: 1, //分页信息
				pageSize: 10,
				total: 0,
				pageList: [10, 20, 50, 100], // 显示条数数组
			},
			leftRow: {
				id: null,
			},
			tableIten: {
				id: '',
				sname: '',
				pid: '',
				newFlag: 1,
				sort: '',
				level: '', // 层级
				nodeType: '', // 结构码表
				nodeTypeName: '', // 结构名称
				status: 1,
				temId: '',
				nodeCode: '',
			},
			currentRow: {},
			deleteArr: [],
			maxLevel: '', // 最高层级
			showSelect: false,
			showList: [],
		}
	},
	computed: {
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),
	},
	created() {
		this.getTableList()
		this.showList = this.projectDict.xmjgjgjd.filter(
			(x) => x.value <= 1057006
		)
	},
	methods: {
		initSearch(row) {
			this.leftRow = row
			this.clearCurrent()
			this.getTableList()
		},

		// 获取右侧树结构数据
		getTableList() {
			let temId = this.leftRow?.id || ''
			if (!!temId === false) {
				return
			}
			this.tableObj.loading = true
			if (temId) {
				let param = {
					temId,
				}
				getProTree(param)
					.then((res) => {
						this.tableObj.data = res.data.treeArr
						// 获取到最高层级的值
						this.maxLevel = res.data.maxLevel
						this.$emit('getLevel', this.maxLevel)
						this.tableObj.defaultData = JSON.parse(
							JSON.stringify(res.data.treeArr)
						)
						setTimeout(() => {
							this.tableObj.loading = false
						}, 1000)
						this.$nextTick(() => {
							this.$refs.tableData.setAllTreeExpand(true)
						})
					})
					.finally(() => {
						this.tableObj.loading = false
					})
				return
			}
			this.tableObj.loading = false
		},

		// 搜索树
		searchTree(sname) {
			let filterName = sname.toString().trim()
			this.tableObj.data = []
			this.loading = true
			if (filterName) {
				let options = { children: 'children' }
				let searchProps = ['sname']

				// 树形显示
				this.tableObj.data = this.$utils.searchTree(
					this.tableObj.defaultData,
					(item) =>
						searchProps.some(
							(key) =>
								item[key].toString().indexOf(filterName) > -1
						),
					options
				)
				// 搜索之后默认展开所有子节点
				this.$nextTick(() => {
					this.loading = false
					this.$refs.tableData.setAllTreeExpand(true)
				})
			} else {
				this.tableObj.data = this.tableObj.defaultData
				// 搜索之后默认展开所有子节点
				this.$nextTick(() => {
					this.loading = false
					this.$refs.tableData.setAllTreeExpand(true)
				})
			}
		},

		// 表格内按钮点击
		tableBtnClick(type, row, index) {
			if (type == 'delete') {
				this.deleteById(row, index)
			} else if (type == 'change') {
				this.changeState(row)
				this.$refs.tableData.loadData(this.tableObj.data)
			} else if (type == 'copy') {
				this.handleCopy(row)
			}
		},

		// 处理禁用
		handleDisabled(item, row) {
			console.log(row, item)
			let typeFlag = null,
				flag = null
			// 单项工程只能有一个，如果已经有了一个，则不允许再选择
			if (row.level == 1 && row.children && row.children.length != 0) {
				typeFlag = row.children.find(
					(key) => key.nodeTypeName == '单项工程'
				)
			}
			// 节点层级：单项工程→子项工程→单位工程→子单位工程→分部工程→子分部工程→分项工程→子分项工程→检验批，上级可以添加任意下级，下级不能添加上级
			if (parseFloat(row.nodeType) - parseFloat(item.value) >= 0) {
				flag = true
			} else if (parseFloat(row.nodeType) - parseFloat(item.value) < 0) {
				flag = false
				// 如果已经有了"单位工程"，则禁用
				if (typeFlag && item.sname == '单项工程') {
					flag = true
				}
			}

			return flag
		},

		//  添加下一项
		handleCommand($event, row) {
			let nodeObj = {}
			let nodeName = ''

			// 找到点击的哪一项
			nodeObj = this.$utils.find(
				this.showList,
				(item) => item.value == $event
			)
			// 如果存在，名称赋值
			if (nodeObj) {
				nodeName = nodeObj.sname
			}

			// 复制
			let newItem = JSON.parse(JSON.stringify(this.tableIten))
			// id生成
			newItem.id = this.Snowflake.nextId()
			this.showSelect = true
			newItem.pid = row.id
			newItem.level = row.level + 1
			newItem.nodeType = $event
			newItem.nodeTypeName = nodeName
			newItem.temId = row.temId
			row.children =
				row.children && row.children.length ? row.children : []
			row.children.push(newItem)
			this.$refs.tableData.loadData(this.tableObj.data)
			this.$refs.tableData.setTreeExpand(row, true)
		},

		// 处理节点类型
		handleNode(row) {
			let options = []
			switch (row.nodeTypeName) {
				case '单项工程':
					options = this.projectDict.xjdxgclx
					break
				case '子单项工程':
					options = this.projectDict.zdxgclx
					break
				case '单位工程':
					options = this.projectDict.xjdwgclx
					break
				case '子单位工程':
					options = this.projectDict.zdwgclx
					break
				case '分部工程':
					options = this.projectDict.fbgclx
					break
				case '子分部工程':
					options = this.projectDict.zfbgclx
					break
				case '分项工程':
					options = this.projectDict.fxgclx
					break
				case '子分项工程':
					options = this.projectDict.zfxgclx
					break
				case '检验批':
					options = this.projectDict.jyplx
					break
			}

			return options
		},

		// 处理复制功能
		handleCopy(row) {
			let parentObj = null
			let newData = null

			// 找到选中数据的父级
			parentObj = this.$utils.findTree(
				this.tableObj.data,
				(item) => item.id === row.pid
			).item
			// 复制选中数据
			newData = Object.assign({}, row)
			// id重新生成
			newData.id = this.Snowflake.nextId()
			newData.newFlag = 1
			// 删除row_key值，避免重复报错
			delete newData._X_ROW_KEY
			// 选中的子级，数据处理，id全部重新生成，其他数据不变
			let arr = this.$utils.mapTree(newData.children, (item) => {
				return {
					id: this.Snowflake.nextId(),
					pid: item.pid,
					level: item.level,
					nodeType: item.nodeType,
					nodeTypeName: item.nodeTypeName,
					temId: item.temId,
					sname: item.sname,
					newFlag: 1,
					status: item.status,
					nodeCode: item.nodeCode,
					sort: item.sort,
				}
			})

			newData.children = arr

			parentObj.children.push(newData)
			// 重新加载表格
			this.$refs.tableData.loadData(this.tableObj.data)
			this.$refs.tableData.setTreeExpand(parentObj, true)
		},

		// 是否生效状态切换
		changeState(row) {
			if (!row.children) {
				return
			}
			if (row.children && row.children.length) {
				row.children.map((val) => {
					val.status = row.status
					this.changeState(val)
				})
			}
		},
		// 删除某一行数据
		deleteById(row, index) {
			if (row.pid == 0) {
				this.$message.warning('根节点不可删除')
				return
			}
			let pObj = this.$utils.findTree(
				this.tableObj.data,
				(x) => x.id == row.pid
			).item
			this.$confirm('确认删除吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					this.deleteArr.push(row)
					pObj.children.splice(index, 1)
					this.$refs.tableData.loadData(this.tableObj.data)
				})
				.catch(() => {})
		},
		// 编辑框校验，暂时不做
		// checkName({ row }) {
		// 	let pObj = this.$utils.findTree(this.tableObj.data, (x) => x.id == row.pid).item
		// 	let obj = this.$utils.countBy(pObj.children, 'sname')
		// 	if (row.sname && obj[row.sname] > 1) {
		// 		this.$message.error('同级节点名称已重复，请重新填写节点名称')
		// 		row.sname = ''
		// 	}
		// },
		// 选中某一行
		onCurrentChange(row) {
			this.currentRow = row
		},

		// 节点类型名称
		formatType(row) {
			let nodeName = ''
			switch (row.nodeTypeName) {
				case '单项工程':
					nodeName = this.handleData(
						this.projectDict.xjdxgclx,
						row.nodeCode
					)
					break
				case '子单项工程':
					nodeName = this.handleData(
						this.projectDict.zdxgclx,
						row.nodeCode
					)
					break
				case '单位工程':
					nodeName = this.handleData(
						this.projectDict.xjdwgclx,
						row.nodeCode
					)
					break
				case '子单位工程':
					nodeName = this.handleData(
						this.projectDict.zdwgclx,
						row.nodeCode
					)
					break
				case '分部工程':
					nodeName = this.handleData(
						this.projectDict.fbgclx,
						row.nodeCode
					)
					break
				case '子分部工程':
					nodeName = this.handleData(
						this.projectDict.zfbgclx,
						row.nodeCode
					)
					break
				case '分项工程':
					nodeName = this.handleData(
						this.projectDict.fxgclx,
						row.nodeCode
					)
					break
				case '子分项工程':
					nodeName = this.handleData(
						this.projectDict.zfxgclx,
						row.nodeCode
					)
					break
				case '检验批':
					nodeName = this.handleData(
						this.projectDict.jyplx,
						row.nodeCode
					)
					break
			}
			if (row.level == 1) {
				nodeName = '-'
			}
			return nodeName
		},

		// 数据处理
		handleData(data, value) {
			let newName = ''
			data.map((item) => {
				if (item.value === value) {
					newName = item.sname
				}
			})
			return newName
		},

		// 移动顺序
		handleMove(type) {
			// 找到自己的下标
			let _index = this.currentRow.$rowIndex
			if (_index == undefined) {
				this.$message.warning(
					`请选择需要${type == 'up' ? '升序' : '降序'}的节点名称`
				)
				return
			}
			//根节点无法移动
			if (this.currentRow.row.level == 1) {
				this.$message.warning(`该节点无法移动，请重新选择！`)
				return
			}
			// 找到父节点
			let pObj = this.$utils.findTree(
				this.tableObj.data,
				(x) => x.id == this.currentRow.row.pid
			).item
			let moveList = []
			// 获取移动的两个元素
			moveList = this.dealIndex(type, _index, pObj)
			// 接收到的moveList 不存在就return
			if (!moveList) {
				return
			}
			// 拷贝moveList
			let copyObj = this.$utils.clone(moveList, true)
			if (type == 'up') {
				this.$set(pObj.children, _index, copyObj[1])
				this.$set(pObj.children, _index - 1, copyObj[0])
				this.currentRow.$rowIndex = _index - 1
			} else {
				this.$set(pObj.children, _index, copyObj[1])
				this.$set(pObj.children, _index + 1, copyObj[0])
				this.currentRow.$rowIndex = _index + 1
			}
			this.$refs.tableData.loadData(this.tableObj.data)
			this.$emit('getLevel', this.maxLevel)
			this.$refs.tableData.setAllTreeExpand(true)
		},

		// 移动节点时，判断节点是不是最上面或者最下面
		dealIndex(type, _index, pObj) {
			let moveList = []
			if (type == 'up') {
				// 像上移 如果已经是最上面的 则不能移动
				if (_index == 0) {
					this.$message.error(
						'已到该级别最高节点，无法再升序，可操作降序'
					)
					return
				}
				// 上移将当前下标的元素 和 前一个元素加到 movelist
				moveList = [pObj.children[_index], pObj.children[_index - 1]]
			} else {
				// 像下移 如果已经是最下面的 则不能移动
				if (!pObj.children[_index + 1]) {
					this.$message.error(
						'已到该级别最低节点，无法再降序，可操作升序'
					)
					return
				}
				// 下移将当前下标的元素 和 后一个元素加到 movelist
				moveList = [pObj.children[_index], pObj.children[_index + 1]]
			}
			return moveList
		},
		// 判断删除按钮的禁用状态
		formatEdit(row) {
			return !this.isEdit || (row.children && row.children.length > 0)
		},

		// 判断复制按钮的禁用状态
		copyDisabled(row) {
			return (
				!this.isEdit ||
				(this.leftRow.temType == 0 && row.nodeTypeName == '单项工程')
			)
		},

		// 保存按钮
		doSave() {
			this.tableObj.data.map((item) => {
				this.sortData(item)
			})
			let param = {
				temId: this.leftRow.id,
				trees: this.tableObj.data,
				deleteArr: this.deleteArr,
			}
			saveProTree(param).then((res) => {
				this.$message({ message: '保存成功！', type: 'success' })
				this.deleteArr = []
				this.getTableList()
				this.$emit('change-edit')
			})
		},
		// 给数据先排序
		sortData(data) {
			if (!data.children || data.children.length == 0) {
				return
			}
			data.children.map((item, index) => {
				item.sort = index + 1
				this.sortData(item)
			})
		},
		// 当左侧切换模板时，清除当前选中行数据
		clearCurrent() {
			this.currentRow = {}
			this.deleteArr = []
		},
		/* 根据层级获取节点
		 * @param {*} list 数据
		 * @param {*} hierarchy 层级
		 * @param {*} nodeName 子节点的名称
		 * @returns 结果
		 * */
		getNodeByHierarchy(list, hierarchy, nodeName = 'children') {
			if (list && list.length) {
				if (hierarchy > 1) {
					const allRow = []
					list.forEach((item) => {
						allRow.push(item)
						if (item[nodeName]) {
							allRow.push(
								...this.getNodeByHierarchy(
									item[nodeName],
									hierarchy - 1,
									nodeName
								)
							)
						}
					})
					return allRow
				} else if (hierarchy == 1) {
					return list
				} else return []
			} else return []
		},

		expandByHierarchy(value) {
			this.$refs.tableData.setAllTreeExpand(false)
			const rows = this.getNodeByHierarchy(this.tableObj.data, value)
			this.$refs.tableData.setTreeExpand(rows, true)
		},
	},
}
</script>
<style lang="less"></style>
